import { ResourceService } from 'src/app/services/resource.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DepositPolicyPaymentTypes } from 'src/app/models/enums/BookingEnums';
import { PaymentMode, RentalServiceDeliveryChannel } from 'src/app/models/enums/Payments/PaymnetsEnum';
import { BookingService } from 'src/app/services/booking.service';

@Component({
  selector: 'paymnet-exportable',
  templateUrl: './paymnet-exportable.component.html',
  styleUrls: ['./paymnet-exportable.component.css']
})
export class PaymnetExportableComponent implements OnInit {
  caseID: any;
  depositeType: DepositPolicyPaymentTypes;
  paymentMode: PaymentMode;
  paymentValue: number;
  rentalServiceDeliveryChannel: RentalServiceDeliveryChannel;
  customerID: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private bookingService: BookingService,
    private resourceService: ResourceService
  ) { }

  ngOnInit() {

    this.resourceService.updateExportableComponantFlag(true);

    this.caseID = this.route.snapshot.queryParams.caseID == null ? this.route.snapshot.params.caseID : this.route.snapshot.queryParams.caseID;
    let depositeType = this.route.snapshot.queryParams.depositeType == null ? this.route.snapshot.params.depositeType : this.route.snapshot.queryParams.depositeType;
    let paymentMode = this.route.snapshot.queryParams.paymentMode == null ? this.route.snapshot.params.paymentMode : this.route.snapshot.queryParams.paymentMode;
    let paymentValue = this.route.snapshot.queryParams.paymentValue == null ? this.route.snapshot.params.paymentValue : this.route.snapshot.queryParams.paymentValue;
    let rentalServiceDeliveryChannel = this.route.snapshot.queryParams.rentalServiceDeliveryChannel == null ? this.route.snapshot.params.rentalServiceDeliveryChannel : this.route.snapshot.queryParams.rentalServiceDeliveryChannel;
    let languageID = this.route.snapshot.queryParams.languageID == null ? this.route.snapshot.params.languageID : this.route.snapshot.queryParams.languageID;
    let customerID = this.route.snapshot.queryParams.customerID == null ? this.route.snapshot.params.customerID : this.route.snapshot.queryParams.customerID;

    if (depositeType != null) {
      this.depositeType = Number(depositeType);
    }


    if (paymentMode != null) {
      this.paymentMode = Number(paymentMode);
    }

    if (paymentValue != null) {
      this.paymentValue = Number(paymentValue);
    }

    if (rentalServiceDeliveryChannel != null) {
      this.rentalServiceDeliveryChannel = Number(rentalServiceDeliveryChannel);
    }

    if (customerID != null) {
      this.customerID = customerID;
    }

    this.resourceService.supportedLanguages.subscribe(res => {
      if (res != null) {
        let selectedCurriency = res[0];
        if (languageID != null) {
          let langModel = res.filter(a => a.id == languageID)[0];
          if (langModel != null) {
            selectedCurriency = langModel;
          }
        }
        this.resourceService.updateSelectedLanguage(selectedCurriency);
        this.resourceService.cachedSelectedLanguage(selectedCurriency);
      }
    })





  }

}
